import { map } from 'rxjs/operators'

import { get, put } from 'utils/rxfetch'

// Account Takeover detection settings (sensitivity + auto-classification).
// Backend contract is camelCase JSON (CamelCaseJSONRenderer/Parser), so send and
// read camelCase keys directly. See webapp/rest/urls.py -> settings/account-takeover.
const BASE = '/members-api/settings/account-takeover'

// MSP partner scoping: mirror the other settings endpoints and pass the selected
// child company id through the companyFilter query param.
const withCompany = (path, companyId = '') =>
  companyId ? `${path}?companyFilter=${companyId}` : path

export default () => ({
  getSettings(companyId = '') {
    return get(withCompany(BASE, companyId))
  },
  // PUT accepts { sensitivity, isAutoClassify, actions }. atoEnabled is
  // response-only (derived capability) and is ignored if sent. Unlike `get`,
  // rxfetch's `put` emits the raw ajax response, so unwrap `.response` here to
  // return the parsed, freshly-saved settings body (matching getSettings).
  saveSettings(body, companyId = '') {
    return put(withCompany(BASE, companyId), body).pipe(map((x) => x.response))
  },
})
